
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apprendre",
      function () {
        return require("private-next-pages/apprendre/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apprendre"])
      });
    }
  